import { useState, useEffect } from 'react';

interface UseCountUpOptions {
  start?: number;
  end: number;
  duration?: number;
  decimals?: number;
}

export const useCountUp = ({ start = 0, end, duration = 2000, decimals = 0 }: UseCountUpOptions) => {
  const [count, setCount] = useState(start);

  useEffect(() => {
    if (start === end) {
      setCount(end);
      return;
    }

    const startTime = Date.now();
    const range = end - start;

    const timer = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      
      const currentValue = start + (range * easeOutQuart);
      
      if (progress === 1) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.round(currentValue * Math.pow(10, decimals)) / Math.pow(10, decimals));
      }
    }, 16); // ~60fps

    return () => clearInterval(timer);
  }, [start, end, duration, decimals]);

  return count;
};